import { isMobileDevice } from '_metronic/assets/ts/_utils'
import { useContext } from 'react'
import { UIContext } from 'Context/UI'

const ContentToolbar = () => {
	const isMobile = isMobileDevice()
	const { showContentToolbar, customContentToolbar } = useContext(UIContext)

	return (
		<>
			{showContentToolbar ? (
				customContentToolbar ? (
					customContentToolbar
				) : (
					<div
						className="d-flex flex-row-reverse flex-lg-row justify-content-end justify-content-lg-between align-items-center mb-5"
						style={{ columnGap: '12px' }}>
						<button className="btn btn-sm white-button">
							<img
								src="/media/icons/kumopack/calendar.png"
								alt="Kumopack Calendar Icon"
								width={20}
								height={20}
							/>{' '}
							{isMobile ? 'Jan 6, 2022' : 'Jan 6, 2022 - Jan 13, 2022'}
						</button>

						<div className="kumopack-button-group">
							<button className="btn btn-sm white-button left">Marketplace</button>
							<button className="btn btn-sm white-button right">OEM</button>
						</div>
					</div>
				)
			) : null}
		</>
	)
}

export default ContentToolbar
